var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 6,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_526_7728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8978 11.2664C28.4206 11.2664 28.9219 11.474 29.2916 11.8437C29.6613 12.2134 29.8689 12.7147 29.8689 13.2375V25.0645C29.8689 25.5873 29.6613 26.0887 29.2916 26.4584C28.9219 26.828 28.4206 27.0357 27.8978 27.0357H25.9266V29.0069C25.9266 29.5297 25.7189 30.031 25.3493 30.4007C24.9796 30.7704 24.4782 30.978 23.9554 30.978H14.0996C13.5768 30.978 13.0754 30.7704 12.7058 30.4007C12.3361 30.031 12.1284 29.5297 12.1284 29.0069V17.1799C12.1284 16.6571 12.3361 16.1557 12.7058 15.786C13.0754 15.4164 13.5768 15.2087 14.0996 15.2087H16.0708V13.2375C16.0708 12.7147 16.2784 12.2134 16.6481 11.8437C17.0178 11.474 17.5191 11.2664 18.0419 11.2664H27.8978ZM19.0275 24.079H17.0563C16.8051 24.0792 16.5635 24.1754 16.3809 24.3479C16.1982 24.5203 16.0883 24.756 16.0735 25.0068C16.0588 25.2575 16.1404 25.5045 16.3016 25.6971C16.4629 25.8898 16.6916 26.0136 16.941 26.0432L17.0563 26.0501H19.0275C19.2787 26.0498 19.5203 25.9537 19.703 25.7812C19.8857 25.6088 19.9956 25.3731 20.0103 25.1223C20.025 24.8715 19.9434 24.6246 19.7822 24.432C19.621 24.2393 19.3923 24.1155 19.1428 24.0859L19.0275 24.079ZM27.8978 13.2375H18.0419V15.2087H23.9554C24.4782 15.2087 24.9796 15.4164 25.3493 15.786C25.7189 16.1557 25.9266 16.6571 25.9266 17.1799V25.0645H27.8978V13.2375ZM20.9987 20.1366H17.0563C16.7949 20.1366 16.5443 20.2405 16.3594 20.4253C16.1746 20.6101 16.0708 20.8608 16.0708 21.1222C16.0708 21.3836 16.1746 21.6343 16.3594 21.8191C16.5443 22.0039 16.7949 22.1078 17.0563 22.1078H20.9987C21.2601 22.1078 21.5108 22.0039 21.6956 21.8191C21.8804 21.6343 21.9843 21.3836 21.9843 21.1222C21.9843 20.8608 21.8804 20.6101 21.6956 20.4253C21.5108 20.2405 21.2601 20.1366 20.9987 20.1366Z",
    fill: "#6A2C8D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_526_7728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.654,
    height: 23.654,
    fill: "white",
    transform: "translate(9.17188 9.29517)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyPurple);
export default __webpack_public_path__ + "static/media/copy-purple.fed95d9f011b5abcff43b4313c96cd40.svg";
export { ForwardRef as ReactComponent };